import React from "react";

export default function comoReservar(){


    return(
        <div>
            <h1>RESERVAR</h1>
        </div>
    )
}